import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  type PostAttachmentRequestType,
  type PostAttachmentResponseType,
  postAttachment,
} from '..';
import { queryKey } from './query-key';

export const usePostAttachment = () => {
  const queryClient = useQueryClient();

  const onSuccess = async (
    _data: PostAttachmentResponseType,
    variables: PostAttachmentRequestType,
  ) => {
    await queryClient.refetchQueries(
      queryKey.documentAttachments(variables.documentId),
    );
    await queryClient.refetchQueries(queryKey.document(variables.documentId));
    await queryClient.refetchQueries(
      queryKey.documentsQueue(variables.documentId),
    );
    await queryClient.refetchQueries(
      queryKey.documentsVersions(variables.documentId),
    );
    await queryClient.refetchQueries(
      queryKey.documentComments(variables.documentId),
    );
  };

  return useMutation({
    mutationFn: postAttachment,
    onSuccess,
  });
};
